import { OtherDealerInventoryItem } from "../components/OtherDealerInventoryGrid/types";

export interface OtherDealerInventoryState {
  items: OtherDealerInventoryItem[];
  isLoading: boolean;
  error: boolean;
  currentPage: number;
  pageSize: number;
  totalItems: number;
  sortModel: { field: string; sort: string }[];
}

export const initialState: OtherDealerInventoryState = {
  items: [],
  isLoading: false,
  error: false,
  currentPage: 1,
  pageSize: 10,
  totalItems: 0,
  sortModel: [],
};

export enum ActionTypes {
  SET_LOADING = "SET_LOADING",
  SET_ERROR = "SET_ERROR",
  SET_ITEMS = "SET_ITEMS",
  SET_CURRENT_PAGE = "SET_CURRENT_PAGE",
  SET_PAGE_SIZE = "SET_PAGE_SIZE",
  SET_SORT_MODEL = "SET_SORT_MODEL",
}
export type OtherDealerInventoryActions =
  | { type: ActionTypes.SET_LOADING; payload: boolean }
  | { type: ActionTypes.SET_ERROR; payload: boolean }
  | {
      type: ActionTypes.SET_ITEMS;
      payload: { items: OtherDealerInventoryItem[]; totalItems: number };
    }
  | { type: ActionTypes.SET_CURRENT_PAGE; payload: number }
  | { type: ActionTypes.SET_PAGE_SIZE; payload: number }
  | {
      type: ActionTypes.SET_SORT_MODEL;
      payload: { field: string; sort: string }[];
    };

export const reducer = (
  state: OtherDealerInventoryState,
  action: OtherDealerInventoryActions
): OtherDealerInventoryState => {
  switch (action.type) {
    case ActionTypes.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case ActionTypes.SET_ERROR:
      return { ...state, error: action.payload };
    case ActionTypes.SET_ITEMS:
      return {
        ...state,
        items: action.payload.items,
        totalItems: action.payload.totalItems,
        isLoading: false,
      };
    case ActionTypes.SET_CURRENT_PAGE:
      return { ...state, currentPage: action.payload };
    case ActionTypes.SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload, currentPage: 1 };
    case ActionTypes.SET_SORT_MODEL:
      return { ...state, sortModel: action.payload, currentPage: 1 };
    default:
      return state;
  }
};
